import React, { useState, useEffect, useMemo, useCallback } from 'react'
import { Container, Grid, Paper, Button, Stack, Box, Input, Typography, CircularProgress, Alert, InputAdornment, IconButton } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { DateRange } from 'react-date-range'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import SearchIcon from '@mui/icons-material/Search'
import SearchOffIcon from '@mui/icons-material/SearchOff'
import ClearIcon from '@mui/icons-material/Clear'
import BackspaceIcon from '@mui/icons-material/Backspace'
import SaveIcon from '@mui/icons-material/Save'
import Copyright from '../../../General/Copyright'
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import {trackingReports, getProcesses} from '../../../Shared/Fetch'
import DownloadButton from '../../../Shared/DownloadButton'
import TrackingItem from '../Tracking/trackingItem'

// Funciones auxiliares fuera del componente para optimizar memoria
const mapOptions = (items, labelKey, valueKey = 'id') => 
  Array.isArray(items) ? items.map(item => ({ label: item[labelKey], value: item[valueKey] })) : [];

const getAddress = (row, prefix) => {
  if (!row) return '';
  const getVal = (field) => {
    const val = row[`${prefix}_${field}`];
    return val ? val.toString().trim() : '';
  };

  const name = getVal('person');
  const street = getVal('street');
  const extNum = getVal('external_number');
  const intNum = getVal('internal_number');
  const line2 = [street, extNum, intNum].filter(Boolean).join(', ');
  const suburb = getVal('suburb');
  const state = getVal('state');
  const line3 = [suburb, state].filter(Boolean).join(', ');
  const phone = getVal('phone');
  
  return [name, line2, line3, phone].filter(Boolean).join('\n');
};

export default function ReportsIndex() {
  const envConfig = {
      url : (process.env.REACT_APP_ENVIROMENT === "prod") ? process.env.REACT_APP_URL_PROD : process.env.REACT_APP_URL_DEV
  };
  const actualDate = new Date()
  const previousDate = new Date(actualDate.getTime() - 3 * 24 * 60 * 60 * 1000)

  const [loading, setLoading] = useState(false)
  const [reports, setReports] = useState(undefined)
  const [tableSearch, setTableSearch] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState('')

  const [carriers, setCarriers] = useState([])
  const [processes, setProcesses] = useState([])
  const [companies, setCompanies] = useState([])
  const [users, setUsers] = useState([])
  
  const [operation, setOperation] = useState({ opMovement: 0 })
  const [companieId, setCompanieId] = useState({ companieId: 0 })
  const [userId, setUserId] = useState({ userId: 0 })
  const [carrierId, setCarrierId] = useState({ carrierId: 0 })
  const [openTracking, setOpenTracking] = useState(false)
  const [trackingData, setTrackingData] = useState({})

  const [UUIDValue, setUUIDValue] = useState('');
  const [descarga, setDescarga] = useState(false);
  const [dateRange, setDateRange] = useState([
    {
      startDate: previousDate,
      endDate: actualDate,
      key: 'selection'
    }
  ])

  // const isValidUUID = value.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/);
  // const UUIDValue = isValidUUID ? value : null;
  const filters = [
    { id: 'todos', name: 'Todos' },
    { id: 'proceso', name: 'Proceso' },
    { id: 'usuario', name: 'Usuario' },
    { id: 'compania', name: 'Compañía' },
    { id: 'carrier', name: 'Carrier' }
  ];

  async function saveReports() {
    try {
    setLoading(true);
    setDescarga(true);
      const params = new URLSearchParams({
      UUIDValue: UUIDValue,
      userId: userId['userId'],
      companieId: companieId['companieId'],
      operation: operation['opMovement'],
      carrierId: carrierId['carrierId'],
      start: dateRange[0].startDate.toISOString().split('T', 1),
      end: dateRange[0].endDate.toISOString().split('T', 1)
    })
    
    const response = await fetch(`${envConfig.url}/api/v2/reports/save?${params}`, {
      method: 'GET',
      headers: {
          'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
          'Cache-Control': 'no-cache'
      }
  });
  
    if (response.ok) {
      
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = `Reporte del ${params.get('start')} hasta el ${params.get('end')}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    }
    setLoading(false)
    
    if (response != null) {
    setReports(response.data)
    }
    }
    catch (error) {
      console.error("Error en la solicitud:", error);
      setReports(null);
    } finally {
      setLoading(false);
    }
  }

  async function getReports() {
    const params = new URLSearchParams({
      UUIDValue: UUIDValue,
      userId: userId['userId'],
      companieId: companieId['companieId'],
      operation: operation['opMovement'],
      carrierId: carrierId['carrierId'],
      start: dateRange[0].startDate.toISOString().split('T', 1),
      end: dateRange[0].endDate.toISOString().split('T', 1)
    })
    setLoading(true);
    await trackingReports(params, setReports);
    setLoading(false);
  }
  
  async function getCarriers() {
    try {
      const response = await fetch(`${envConfig.url}/api/v2/carriers`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          'Cache-Control': 'no-cache'
        }
      });
  
      if (response.ok) {
        const data = await response.json();
        data.data.unshift({ id: 0, name: 'Todos' });
        setCarriers(data.data);
      } else {
        console.error("Error en la respuesta", response);
        setCarriers(null);
      }
    } catch (error) {

      console.error("Error en la solicitud", error);
      setCarriers(null);
    }
  }
      
  async function getUsers() {
    try {
      const response = await fetch(`${envConfig.url}/api/v2/users`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          'Cache-Control': 'no-cache'
        }
      });
  
      if (response.ok) {
        const data = await response.json();
        let filteredUsers = data.users;
        if (companieId.companieId && companieId.companieId !== 0) {
          filteredUsers = data.users.filter(user => user.empresa_id === companieId.companieId);
        }
        filteredUsers.unshift({ id: 0, name: 'Todos' });
        setUsers(filteredUsers);
      } else {
        console.error("Error en la respuesta", response);
        setUsers([]);
      }
    } catch (error) {

      console.error("Error en la solicitud", error);
      setUsers([]);
    }
  }
  async function getCompanies() {
    try {
      const response = await fetch(`${envConfig.url}/api/v2/companies`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          'Cache-Control': 'no-cache'
        }
      });
  
      if (response.ok) {
        const data = await response.json();
        data.companies.unshift({ id: 0, nombre_comercial: 'Todos' });
        setCompanies(data.companies);
      } else {
        console.error("Error en la respuesta", response);
        setCompanies([]);
      }
    } catch (error) {

      console.error("Error en la solicitud", error);
      setCompanies([]);
    }
  }
  const [isValidUUID, setIsValidUUID] = useState(true);

  const handleUUIDChange = (event) => {
    const value = event.target.value;
    setUUIDValue(value);
  };
  
  useEffect(() => {
    const isValid = (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(UUIDValue)||UUIDValue==='');
    setIsValidUUID(isValid);
  }, [UUIDValue]);

  const handleTrackingClick = useCallback(async (waybill) => {
    setOpenTracking(true)
    setTrackingData({})
    try {
      const response = await fetch(
        `${envConfig.url}/api/v2/tracking?waybills=${JSON.stringify([waybill])}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            "Cache-Control": "no-cache"
          }
        });
      const data = await response.json();
      if (data.data && data.data.length > 0) {
        setTrackingData(data.data[0]);
      }
    } catch (error) {
      console.error(error);
    }
  }, [envConfig.url])

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(tableSearch)
    }, 1000)

    return () => clearTimeout(timer)
  }, [tableSearch])

  // Carga inicial de datos estáticos
  useEffect(() => {
    getProcesses(setProcesses)
    getCarriers()
    getCompanies()
  }, [])

  // Carga de usuarios dependiente de la compañía
  useEffect(() => {
    getUsers()
  }, [companieId])

  // Definición de columnas memoizada
  const columns = useMemo(() => [
    { field: 'date', headerName: 'Fecha', width: 200 },
    { field: 'process', headerName: 'Proceso', width: 150 },
    { field: 'waybill', headerName: 'Guía', resizable: true, minWidth: 200 },
    { field: 'user', headerName: 'Usuario', width: 150 },
    { field: 'subsidiary', headerName: 'Sucursal', width: 150 },
    { 
      field: 'origen_nombre', 
      headerName: 'Origen', 
      width: 300,
      valueGetter: (value, row) => getAddress(row || value?.row, 'origin'),
      renderCell: (params) => <div style={{ whiteSpace: 'pre-wrap', lineHeight: '1.4', padding: '8px 0' }}>{params.value}</div>
    },
    { 
      field: 'destino_nombre', 
      headerName: 'Destino', 
      width: 300,
      valueGetter: (value, row) => getAddress(row || value?.row, 'destination'),
      renderCell: (params) => <div style={{ whiteSpace: 'pre-wrap', lineHeight: '1.4', padding: '8px 0' }}>{params.value}</div>
    },
    {
      field: 'actions',
      headerName: 'Acciones',
      width: 380,
      renderCell: (params) => (
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ py: 1 }}>
          {params.row.movimiento_uuid && <DownloadButton type="manifest" identifier={params.row.movimiento_uuid} />}
          {params.row.waybill && <DownloadButton type="waybill" identifier={params.row.waybill} />}
          {params.row.ticket && <DownloadButton type="ticket" identifier={params.row.ticket} />}
          <Button variant="outlined" size="small" onClick={() => handleTrackingClick(params.row.waybill)}>Rastreo</Button>
        </Stack>
      )
    }
  ], [handleTrackingClick]);

  // Filtrado de filas memoizado para el buscador
  const filteredReports = useMemo(() => {
    if (!reports) return [];
    if (!debouncedSearch) return reports;

    const searchTerm = debouncedSearch.toLowerCase();
    
    return reports.filter(row => {
      const origin = getAddress(row, 'origin').toLowerCase();
      const destination = getAddress(row, 'destination').toLowerCase();
      const waybill = (row.waybill || '').toString().toLowerCase();
      const user = (row.user || '').toString().toLowerCase();
      return origin.includes(searchTerm) || destination.includes(searchTerm) || waybill.includes(searchTerm) || user.includes(searchTerm);
    });
  }, [reports, debouncedSearch]);

  // Opciones memoizadas para los autocompletes
  const carrierOpts = useMemo(() => mapOptions(carriers, 'name'), [carriers]);
  const processOpts = useMemo(() => mapOptions(processes, 'name'), [processes]);
  const companyOpts = useMemo(() => mapOptions(companies, 'nombre_comercial'), [companies]);
  const userOpts = useMemo(() => mapOptions(users, 'name'), [users]);

  return (
    <Container
      maxWidth='lg'
      sx={{ mt: 4, mb: 4 }}
    >
      {/* Main */}

      <Grid
        container
        spacing={3}
        direction={{ xs: 'column', md: 'row' }}
      >
        {/* Formulario */}
        <Grid
          item
          xs={12}
          md='auto'
        >
          <Paper sx={{ p: 2 }}>
            <Stack
              spacing={2}
              direction={{ xs: 'column', sm: 'row', md: 'column' }}
            >
              {/* Calendario */}
              <DateRange
                editableDateInputs={false}
                sx={{ width: '100%' }}
                onChange={item => setDateRange([item.selection])}
                moveRangeOnFirstSelection={true}
                ranges={dateRange}
              />

              {/* Botones */}
              <Stack
                spacing={2}
                sx={{ width: '100%' }}
              >
                {/* Selector */}
                <Autocomplete
                  disablePortal
                  id="carrier-autocomplete"
                  options={carrierOpts}
                  sx={{ width: '100%' }}
                  getOptionLabel={(option) => option.label}
                  onChange={(event, newValue) => {
                    setCarrierId({ carrierId : newValue ? newValue.value : 0 });
                  }}
                  renderInput={(params) => <TextField {...params} label="Carriers" />}
                  isOptionEqualToValue={(option, value) => option.value === value}
                  value={carrierOpts.find(p => p.value === carrierId.carrierId) || null}
                />
                
                <Autocomplete
                  disablePortal
                  id="process-autocomplete"
                  options={processOpts}
                  sx={{ width: '100%' }}
                  getOptionLabel={(option) => option.label}
                  onChange={(event, newValue) => {
                    setOperation({ opMovement: newValue ? newValue.value : 0 });
                  }}
                  renderInput={(params) => <TextField {...params} label="Proceso" />}
                  isOptionEqualToValue={(option, value) => option.value === value}
                  value={processOpts.find(p => p.value === operation.opMovement) || null}
                />
                 
                 <Autocomplete
                    disablePortal
                    id="companie-autocomplete"
                    options={companyOpts}
                    sx={{ width: '100%' }}
                    getOptionLabel={(option) => option.label}
                    onChange={(event, newValue) => {
                      setCompanieId({ companieId: newValue ? newValue.value : 0});
                    }}
                    renderInput={(params) => <TextField {...params} label="Compañía" />}
                    isOptionEqualToValue={(option, value) => option.value === value}
                    value={companyOpts.find(c => c.value === companieId.companieId) || null}
                  />
                <Autocomplete
                  disablePortal
                  id="user-autocomplete"
                  options={userOpts}
                  sx={{ width: '100%' }}
                  getOptionLabel={(option) => option.label}
                  onChange={(event, newValue) => {
                    setUserId({ userId: newValue ? newValue.value :0 });
                  }}
                  renderInput={(params) => <TextField {...params} label="Usuario" />}
                  isOptionEqualToValue={(option, value) => option.value === value}
                  value={userOpts.find(u => u.value === userId.userId) || null}
                />
                <Input
                  value={UUIDValue}
                  sx={{ width: '100%', margin: 2 }}
                  onChange={(value) => handleUUIDChange(value)}
                  placeholder="Ingrese un UUID"
                />
                <Alert severity="warning" sx={{ display: isValidUUID ? 'none' : 'block' }}>El UUID no es válido</Alert>

                {/* <p>Valor a enviar: {UUIDValue ? UUIDValue : 'No válido'}</p> */}

                {/* Enviar */}
                <Button
                  variant='contained'
                  type='submit'
                  onClick={() => getReports()}
                  fullWidth={true}
                  disabled={(loading || !isValidUUID)}
                  startIcon={<SearchIcon />}
                >
                  Buscar
                </Button>

                {/* Guardar */}
                {reports?.length > 0 && loading === false && (
                  <Button
                    variant='outlined'
                    color='info'
                    fullWidth={true}
                    type='reset'
                    disabled={loading}
                    startIcon={<SaveIcon />}
                    onClick={saveReports}
                  >
                    Guardar como Excel
                  </Button>
                  
                )}
                {/* Limpiar */}
                <Button
                  variant='outlined'
                  fullWidth={true}
                  type='reset'
                  disabled={loading}
                  color='error'
                  startIcon={<BackspaceIcon />}
                  onClick={() => {
                    setDateRange([
                      {
                        startDate: previousDate,
                        endDate: actualDate,
                        key: 'selection'
                      }
                    ])
                    setOperation({ opMovement: 0 })
                    setCompanieId({ companieId: 0 })
                    setUserId({ userId: 0 })
                    setCarrierId({ carrierId: 0 })
                    setUUIDValue('');
                    setReports(undefined)
                  }}
                >
                  Limpiar
                </Button>
              </Stack>
            </Stack>
          </Paper>
        </Grid>

        {/* Resultados */}
        <Grid
          item
          xs={12}
          md
        >
          <Paper sx={{ width: '100%', height: '100%', minHeight: '30em', p: 2 }}>
            {reports === undefined && loading === false && (
              <Stack
                paddingX={'20%'}
                justifyContent='center'
                alignContent='center'
                sx={{ height: '100%' }}
              >
                <Box>
                  <SearchIcon sx={{ fontSize: 75 }} />
                </Box>
                <Typography variant='h5'>Generar reporte</Typography>
                <Typography variant='body1'>Para empezar, selecciona un rango de fechas y el proceso del que deseas buscar</Typography>
              </Stack>
            )}

            {loading === true && (
              <Stack
                paddingX={'20%'}
                justifyContent='center'
                alignContent='center'
                sx={{ height: '100%' }}
              >
                <Box>
                  <CircularProgress size={75} />
                </Box>
                <Typography variant='h5'>
                  {descarga ? 'Descargando guías' : 'Buscando guías'}
                </Typography>
                <Typography variant='body1'>Espera un momento en lo que encontramos realizamos la búsqueda</Typography>
              </Stack>
            )}

            {reports !== undefined &&
              loading === false &&
              (reports?.length > 0 ? (
                <Box sx={{ height: '100%', width: '100%' }}>
                  <TextField 
                    fullWidth 
                    label="Buscar por Guía, Usuario, Origen o Destino" 
                    variant="outlined" 
                    size="small"
                    sx={{ mb: 2 }}
                    value={tableSearch}
                    onChange={(e) => setTableSearch(e.target.value)}
                    InputProps={{
                      endAdornment: tableSearch && (
                        <InputAdornment position="end">
                          <IconButton onClick={() => setTableSearch('')} edge="end">
                            <ClearIcon />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                  <DataGrid
                    rows={filteredReports}
                    columns={columns}
                    pageSize={10}
                    rowsPerPageOptions={[10]}
                    getRowId={(row) => row.waybill}
                    getRowHeight={() => 'auto'}
                    disableColumnResize={false}
                  />
                </Box>
              ) : (
                <Stack
                  paddingX={'20%'}
                  justifyContent='center'
                  alignContent='center'
                  sx={{ height: '100%' }}
                >
                  <Box>
                    <SearchOffIcon sx={{ fontSize: 75 }} />
                  </Box>
                  <Typography variant='h5'>Sin resultados</Typography>
                  <Typography variant='body1'>No encontramos guías que cumplan los parámetros que solicitaste</Typography>
                </Stack>
              ))}
          </Paper>
        </Grid>
      </Grid>

      {/* Footer */}
      <Grid
        container
        paddingTop={2}
      >
        <Grid
          item
          xs={12}
        >
          <Paper
            sx={{
              p: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: 50
            }}
          >
            <Copyright sx={{ pt: 4 }} />
          </Paper>
        </Grid>
      </Grid>
      <TrackingItem
        open={openTracking}
        onClose={() => setOpenTracking(false)}
        items={trackingData}
        title={"Rastreo"}
      />
    </Container>
  )
}
